import { Component } from "react";

export class ErrorBoundary extends Component {
  state = { error: null };
  static getDerivedStateFromError(error) { return { error }; }
  componentDidCatch(error, info) { console.error("Page crashed:", error, info?.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="mx-auto max-w-lg rounded-2xl border border-red-500/30 bg-red-500/10 p-6 text-center" data-testid="page-error">
        <p className="font-display text-lg text-zinc-100">This section hit a problem loading.</p>
        <p className="mt-2 text-sm text-zinc-400">The rest of the app still works. Try again, or come back in a moment.</p>
        <p className="mt-3 break-words font-mono text-[11px] text-red-300/80" data-testid="page-error-detail">{String(this.state.error?.message || this.state.error)}</p>
        <button onClick={() => this.setState({ error: null })} className="mt-4 rounded-full bg-[#D4AF37] px-5 py-2 text-sm font-semibold text-black" data-testid="page-error-retry">Try again</button>
      </div>
    );
  }
}
